import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    {
        path: 'app', children: [
            { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [authGuard] },
            { path: 'general', loadChildren: () => import('./features/general/general.module').then(m => m.GeneralModule), canActivate: [authGuard] , data:{permission:'general'}},
            { path: 'rescue', loadChildren: () => import('./features/rescue/rescue.module').then(m => m.RescueModule), canActivate: [authGuard] , data:{permission:'rescue'}},
            { path: 'restore', loadChildren: () => import('./features/restore/restore.module').then(m => m.RestoreModule), canActivate: [authGuard] , data:{permission:'restore'}},
            { path: 'vehicles', loadChildren: () => import('./features/vehicles/vehicle.module').then(m => m.VehicleModule), canActivate: [authGuard] , data:{permission:'vehicles'}},
            { path: 'users', loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule), canActivate: [authGuard] , data:{permission:'users'} },
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
        ]
    },
    { path: '', redirectTo: 'app/dashboard', pathMatch: 'full' },
    { path: '**', redirectTo: 'app/dashboard', pathMatch: 'full' },
];
